// Loads the official Razorpay Checkout script exactly once. Resolves true when
// window.Razorpay is available, false on load failure. The secret never touches
// the browser — only the public Key ID from the backend create-order response.
const CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";
let _loading = null;

export function loadRazorpayScript() {
  if (typeof window !== "undefined" && window.Razorpay) return Promise.resolve(true);
  if (_loading) return _loading;
  _loading = new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${CHECKOUT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve(true));
      existing.addEventListener("error", () => { _loading = null; resolve(false); });
      if (window.Razorpay) resolve(true);
      return;
    }
    const s = document.createElement("script");
    s.src = CHECKOUT_SRC;
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { _loading = null; resolve(false); };
    document.body.appendChild(s);
  });
  return _loading;
}
